import { render, staticRenderFns } from "./SectionBlogNoticia.vue?vue&type=template&id=7bc72467&"
import script from "./SectionBlogNoticia.vue?vue&type=script&lang=js&"
export * from "./SectionBlogNoticia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogCarouselBlog: require('/opt/buildhome/repo/components/Blog/CarouselBlog.vue').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
